const workoutStepperTranslations = {
  breakWeightPopUp: {
    newRecord: "New Personal Record",
    congratulations: `Congratulations !, You Have Successfully Broke Your Last Record.
        And Now You Can Increase Your Weight Per Set.`,
    keepItUp: "Keep It Up",
  },
  cardioExercises: {
    select: "Select one cardio exercise",
  },
  dropsetPopUp: {
    title: "Dropset Expliantion",
    actionButton: "Cancel",
  },
  supersetExplainationPopUp: {
    title: "Superset Explaination",
    actionButton: "Cancel",
  },
  exercisesCard: {
    set: "Set",
    lastSet: "Last Set Is Drop Set",
    lastAchieved: "Last Achieved",
    actionButton: "Save",
    warmUpSet:"Warm-Up Set"
  },
  exerciseRecordNotice: {
    notice: "Notice",
    newRecord: "You Have New Personal Record",
    wrongTrack: "You Are On Wrong Track",
    moreReps:
      "You made more reps than your reps / exercise, so you can now increase your weight / set.",
    lessReps: `Unfortunately you made less reps than your reps / exercise, please 
        use lighter weights to avoid injuries and have a better progress.`,
    actionButton: "Cancel",
  },
  resetWorkoutRoutinePopUp: {
    title: "Reset Workout Routine Notice",
    description: `You Are About To Reset Your Workout Week, Which Means You Will
        Start From The First Day In Your Workout Week`,
    actionButton: "Cancel",
    reset: "Reset My Workout",
  },
  routineCompleted: {
    congratulations: "Congratulations !",
    suffer: '"Suffer The Pain Of Discipline or the suffer pain of regret"',
    complete: `Another Wokout Day Just Completed, Which Means You Are One Day
        Closer To Your Goal.`,
  },
  strengthExercisePopUp: {
    title: "Exercise Notes",
    noNotes: "You Have No Notes For Today",
    dtails: "Exercise Details",
    dropsetNotice: "Dropset Notice",
  },
  supersetWrapper: {
    title: "Superset Notes",
    read: "I Have Read",
  },
  warmUpCardioExercisePopUp: {
    actionButton: "Done",
  },
  z: {
    title: "Start Exercise",
  },
};

export default workoutStepperTranslations;
